import { render, staticRenderFns } from "./addOrEditActivity.vue?vue&type=template&id=5901c85a&scoped=true"
import script from "./addOrEditActivity.vue?vue&type=script&lang=js"
export * from "./addOrEditActivity.vue?vue&type=script&lang=js"
import style0 from "./addOrEditActivity.vue?vue&type=style&index=0&id=5901c85a&prod&lang=scss&scoped=true"
import style1 from "./addOrEditActivity.vue?vue&type=style&index=1&id=5901c85a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5901c85a",
  null
  
)

export default component.exports